export const MEDICAL_NOTES_LOADED_SUCCESS = 'MEDICAL_NOTES_LOADED_SUCCESS';
export const MEDICAL_NOTES_COUNT_LOADED_SUCCESS = 'MEDICAL_NOTES_COUNT_LOADED_SUCCESS';
export const MEDICAL_NOTE_SET_REVIEWED_SUCCESS = 'MEDICAL_NOTE_SET_REVIEWED_SUCCESS';
export const MEDICAL_NOTES_FILTER_OPTIONS_CHANGED = 'MEDICAL_NOTES_FILTER_OPTIONS_CHANGED';
export const MEDICAL_NOTES_TOGGLE_FILTER_PANEL = 'MEDICAL_NOTES_TOGGLE_FILTER_PANEL';
export const MEDICAL_NOTES_SET_TOTAL_NUMBER_OF_PAGES = 'MEDICAL_NOTES_SET_TOTAL_NUMBER_OF_PAGES';
export const MEDICAL_NOTES_SET_CURRENT_PAGE_NUMBER = 'MEDICAL_NOTES_SET_CURRENT_PAGE_NUMBER';
export const MEDICAL_NOTES_SET_CURRENT_PAGE_URL = 'MEDICAL_NOTES_SET_CURRENT_PAGE_URL';
export const MEDICAL_NOTES_SELECTED_CHANGED = 'MEDICAL_NOTES_SELECTED_CHANGED'
